import React from 'react';
import PropTypes from 'prop-types';
import { InputAdornment, TextField } from '@material-ui/core';

export default function CustomTextField(props) {
  return (
    <TextField
      {...props}
      id={props.id}
      label={props.label}
      color={props.color}
      onChange={props.onChange}
      onKeyPress={props.onKeyPress}
      inputProps={{ maxLength: props.maxLength }}
      fullWidth
      InputProps={{
        endAdornment: (
          <InputAdornment position="end">
            <img src={props.icon} />
          </InputAdornment>
        )
      }}
    />
  );
}
CustomTextField.propTypes = {
  id: PropTypes.string,
  label: PropTypes.string,
  color: PropTypes.string,
  icon: PropTypes.object,
  onChange: PropTypes.func,
  onKeyPress: PropTypes.func,
  maxLength: PropTypes.number
};
